import React from 'react';
import styled from '@emotion/styled';

import { Button } from 'client/shared/Button/NewButton';
import { SCREEN_BREAKPOINTS } from '../../../constants';

const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 100px 5% 0;
  width: 60%;

  button {
    margin: 0 auto;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    padding: 0;
    width: 100%;
  }
`;
const HeaderTitle = styled.h1`
  color: #ffffff;
  font-size: 8rem;
  font-weight: 500;
  margin: 0 0 25px;
  text-align: center;

  span {
    font-weight: 700;
    position: relative;

    &::after {
      bottom: 0;
      content: '\\00AE';
      font-size: 3rem;
      font-weight: 500;
      position: absolute;
    }
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    font-size: 6rem;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.TABLET}px) {
    font-size: 8rem;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    font-size: 5rem;

    span::after {
      font-size: 2rem;
    }
  }
`;
const HeaderSubtitle = styled.p`
  color: #ffffff;
  font-size: 2.5rem;
  letter-spacing: -0.01em;
  line-height: 3.5rem;
  margin: 0 0 30px;
  text-align: center;

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    font-size: 2.2rem;
    line-height: 2.8rem;
    margin: 0 0 25px;
  }
`;

export const HeaderContent = () => {
  return (
    <HeaderContentContainer>
      <HeaderTitle>
        Ads by <span>Anchor</span>
      </HeaderTitle>
      <HeaderSubtitle>
        The all-in-one, flexible podcast monetization platform made for
        everyone, powered by Spotify.
      </HeaderSubtitle>
      <Button color="yellow">Sign Up</Button>
    </HeaderContentContainer>
  );
};
